<template>
  <div id="certification" style="width: 100%; height: 225px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {}
  },
  mounted() {
    const container = document.getElementById('certification')
    const myChart = new Charts(container)
    myChart.setOption({
      grid: { top: 0, bottom: 0 },
      series: [
        {
          type: 'gauge',
          startAngle: -Math.PI / 2,
          endAngle: Math.PI * 1.5,
          arcLineWidth: 10,
          data: [
            {
              name: '无公害认证',
              value: 70,
              gradient: ['#74d5fd', '#3dafde', '#0689bf'],
              radius: '90%',
            },
            {
              name: '绿色认证',
              value: 44,
              gradient: ['#b4fb9c', '#82dc63', '#52c929'],
              radius: '60%',
            },
            {
              name: '有机认证',
              value: 9,
              gradient: ['#f1f997', '#e3ee68', '#dbeb2b'],
              radius: '30%',
            },
          ],
          axisLabel: { show: false },
          axisTick: { show: false },
          pointer: { show: false },
          dataItemStyle: { lineCap: 'round' },
          backgroundArc: { show: false },
          details: {
            show: true,
            formatter: '{name} {value}',
            position: 'start',
            offset: [-10, 0],
            style: {
              fill: '#cfcfcf',
              fontSize: 13,
              textAlign: 'right',
            },
          },
        },
      ],
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/administration-zone/certification-zone.vue